export function SummaryCardDivider() {
  return <div className="w-px self-stretch bg-gray-stroke" aria-hidden="true" />
}
